<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import { useMessageContext } from '../provider.js';

const { contentAttributes } = useMessageContext();

const data = computed(() => contentAttributes.value?.data || {});
const sections = computed(() => data.value.sections || []);
</script>

<template>
  <BaseBubble class="px-4 py-3" data-bubble-name="evolution-list">
    <div class="flex flex-col gap-2">
      <p v-if="data.title" class="font-medium mb-0">{{ data.title }}</p>
      <p v-if="data.description" class="mb-0">{{ data.description }}</p>
      <div
        v-for="(section, sectionIndex) in sections"
        :key="sectionIndex"
        class="flex flex-col gap-1 mt-1"
      >
        <p v-if="section.title" class="text-xs opacity-70 mb-0">
          {{ section.title }}
        </p>
        <div
          v-for="(row, rowIndex) in section.rows"
          :key="rowIndex"
          class="px-3 py-1.5 rounded-lg bg-n-alpha-1"
        >
          <p class="font-medium mb-0">{{ row.title }}</p>
          <p v-if="row.description" class="text-xs opacity-70 mb-0">
            {{ row.description }}
          </p>
        </div>
      </div>
      <p v-if="data.footerText" class="text-xs opacity-70 mb-0 mt-1">
        {{ data.footerText }}
      </p>
    </div>
  </BaseBubble>
</template>
